import { createModuleStore } from '../utils'

export const useEnterprisesStore = createModuleStore(
  'enterprises',
  {
    type: 'Enterprise',
    pageHeading: 'Enterprises',
    noHistory: true,
    sortingOn: 'toolbar',
    uri: '/enterprises',
    serviceUri: '/enterprises',
    uploadOptionsCsv: '',
    statusesFilterName: 'statuses',
    listingModuleName: 'Access Control',
    listingActivityName: 'View Enterprise',
    formModuleName: 'Access Control',
    formActivityName: 'Edit Enterprise',
    allFields: [
      {
        key: 'name',
        title: 'NAME',
        visible: true,
        disabled: true,
        sortable: true,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        visible: true,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        visible: true,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {},
  {
    resetPageFilters() {
      const store = useEnterprisesStore()
      store.resetBaseFilters()
    },
  },
  {
    fields: [
      {
        id: 'enterprise_name',
        name: 'name',
        label: 'Name',
        size: 24,
        component: 'NInput',
        componentProps: { placeholder: 'Enter name of the enterprise' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isNameUnique',
          },
        ],
      },
    ],
  }
)
